import {IIconProps} from '../DataStoreIcon';

const AWSXRay = ({width = '20', height = '20'}: IIconProps) => (
  <svg width={width} height={height} viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1084_22233)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.617676 19.0928L2.60008 20.0979L14.8107 12.0695L2.60008 3.90527L0.617676 4.91045L3.41664 12.0015L0.617676 19.0928Z"
        fill="#4B612C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.27344 11.9956L16.3365 13.1804L18.3974 3.9082L9.27372 6.23366L9.27344 11.9956Z"
        fill="#B7CA9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7124 12.0127L16.4324 12.0155L18.3973 20.0942L9.7124 17.8808V12.0127Z"
        fill="#3C4929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3053 6.12457L2.6001 3.90527L6.34382 12.0015L12.5988 14.4684L11.3053 6.12457Z"
        fill="#B7CA9D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1016 3.55703L10.5117 4.08164V1.41736L12.1016 0.712891V3.55703ZM12.1016 23.2893L10.5117 22.5848V18.7504L12.1016 19.1985V23.2895V23.2893Z"
        fill="#4B612C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.91016 3.53056L10.5117 4.06393V1.41743L8.91016 0.707031V3.53056ZM8.91016 23.2953L10.5117 22.5849V17.5186L8.91016 17.8871V23.2953ZM18.3972 20.0945L20.3824 19.0893L17.6066 12.0011L20.3824 4.91296L18.3972 3.90807L14.6738 12.0011L18.3972 20.0945Z"
        fill="#759C3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9102 0.707031L5.2334 2.57282L7.69241 6.94675L10.4973 11.9334L13.154 5.27833L10.4973 2.93818L8.9102 0.707031Z"
        fill="#4B612C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1014 0.712891L10.5115 2.95873L10.4971 2.98244V11.9333L10.5318 11.9951L13.3454 6.94357L15.7782 2.57868L12.1014 0.712891Z"
        fill="#759C3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8369 12.0098L6.34382 12.0157L2.6001 20.0972L13.8369 17.2324V12.0098Z"
        fill="#3C4929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.69241 17.0531L5.2334 21.4299L8.9102 23.2957L10.4973 21.0645V21.0202L13.5958 19.0042L10.4973 12.0693L7.69241 17.0531Z"
        fill="#4B612C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3454 17.0615L10.5318 12.0068L10.4971 12.0687V21.0195L10.5115 21.0433L12.1014 23.2891L15.7782 21.4233L13.3454 17.0615Z"
        fill="#759C3E"
      />
    </g>
    <defs>
      <clipPath id="clip0_1084_22233">
        <rect width="21" height="24" fill="white" transform="translate(0 0.000976562)" />
      </clipPath>
    </defs>
  </svg>
);

export default AWSXRay;
